module.exports = __webpack_public_path__ + "img/DE00641.5005138c.png";